import { commonRequest } from "../../services/ApiCall";
import { Helpers } from "../../services/Helpers";

export const MediaServices = {
    // Fetch folder list
    fetchFolders: async () => {
        return await commonRequest(
            "GET",
            `${Helpers.URL()}/api/admin/media/list-folders`,
            {},
            Helpers.token()
        );
    },

    // Upload video
    uploadVideo: async (file, path = 'whatsapp') => {
        const formData = new FormData();
        formData.append('file', file);
        
        return await commonRequest(
            "POST",
            `${Helpers.URL()}/api/upload-video/${path}`,
            formData,
            Helpers.token()
        );
    },
    
    // Upload image
    uploadImage: async (file, path = 'whatsapp') => {
        const formData = new FormData();
        formData.append('file', file);
        
        return await commonRequest(
            "POST",
            `${Helpers.URL()}/api/upload-image/${path}`,
            formData,
            Helpers.token()
        );
    },
    
    
    // Fetch video list
    fetchVideoList: async (folder) => {
        // const queryParams = new URLSearchParams();
        // queryParams.append('page', params.page + 1);
        // queryParams.append('limit', params.pageSize);
        
        return await commonRequest(
            "GET",
            `${Helpers.URL()}/api/admin/media/list/videos?folder=${folder}`,
            {},
            Helpers.token()
        );
    },
    
    // Fetch image list
    fetchImageList: async (folder) => {
        return await commonRequest(
            "GET",
            `${Helpers.URL()}/api/admin/media/list/images?folder=${folder}`,
            {},
            Helpers.token()
        );
    },
    
    
    // Delete video
    deleteVideo: async (id) => {
        return await commonRequest(
            "DELETE",
            `${Helpers.URL()}/api/media/video/${id}`,
            {},
            Helpers.token()
        );
    },
    
    // Delete image
    deleteImage: async (id) => {
        return await commonRequest(
            "DELETE",
            `${Helpers.URL()}/api/media/image/${id}`,
            {},
            Helpers.token()
        );
    },
    
    // Delete audio
   
};
